'use client';
import React from 'react';
import { useCmsClientContext } from '../../utils/cmsPageContext';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import { TRANSLATIONS } from './i18n';
import { useProductFilterState } from './ProductFilterProvider';

/**
 * Shown by a results block when the reader's selection matches nothing (R8),
 * with the way out of it (R9): a reader who has filtered themselves into an
 * empty page cannot reach Clear All in the panel on mobile, where the panel is
 * a sheet they have already dismissed.
 *
 * Renders nothing when no filter is active — an empty block with no filters on
 * is an authoring or data problem, and this message would misattribute it.
 */
export const FilterEmptyState: React.FC = () => {
  const { brand, lang } = useCmsClientContext();
  const t = getClientTranslations(TRANSLATIONS, { brand, lang });
  const { activeCount, clearAll } = useProductFilterState();

  if (activeCount === 0) return null;

  return (
    <div
      // A test hook: `docs/testing.md` forbids selecting by Tailwind classes.
      data-filter-empty-state=""
      className="flex flex-col items-start gap-spacing/gap/y-xs rounded-radius/card border border-borders/default bg-fill/card p-6"
    >
      <p className="mhg-alpha-typography-body-1 font-bold text-text/primary">
        {t.sort_and_filter_no_results_title}
      </p>
      <p className="mhg-alpha-typography-body-2 text-text/secondary">
        {t.sort_and_filter_no_results_body}
      </p>
      <button
        type="button"
        onClick={clearAll}
        className="mhg-alpha-typography-button-2 text-text/link"
      >
        {t.sort_and_filter_clear_all}
      </button>
    </div>
  );
};
